export default {
  '_b._qhyy': 'تبديل اللغة',

  '_a._jzz': 'جاري التحميل...',

  '_a._jzgd': 'تحميل المزيد',

  '_a._wct': 'مرحبًا',

  '_a._gd': 'المزيد',

  '_a._bf': 'تشغيل',

  '_a._bcz': 'جاري الحفظ...',

  '_a._sctp': 'تحميل صورة',

  '_dl._qssyx': 'الرجاء إدخال بريدك الإلكتروني',

  '_dl._qssmm': 'الرجاء إدخال كلمة المرور',

  '_dl._ann': 'تسجيل الدخول',

  '_dl._hmyzh': 'ليس لديك حساب؟',

  '_dl._qzc': 'تسجيل',

  '_dl._yzhl': 'هل لديك حساب؟" حساب؟',

  '_dl._qdl': 'تسجيل الدخول',

  '_dl._srqrmm': 'الرجاء إدخال لتأكيد كلمة المرور',
  '_dl._sryqm': 'الرجاء إدخال رمز الدعوة',

  '_dl._sryzm': 'الرجاء إدخال رمز التحقق',

  '_dl._ljzc': 'سجّل الآن',

  '_dl._zcbsty': 'يُشير التسجيل إلى أنك قرأت الشروط ووافقت عليها',

  '_dl._yszc': 'سياسة الخصوصية',

  '_dl._lcmmbyy': 'كلمتا المرور غير متطابقتين',

  '_yzm._fsyzm': 'جارٍ إرسال رمز التحقق',

  '_yzm._cxfs': '({time}) إعادة إرسال',

  '_yzm._fsz': 'جارٍ الإرسال...',

  '_yzm._fscg': 'تم الإرسال" تم بنجاح',

  '_h._zrm': 'الأكثر شيوعًا',

  '_h._zxd': 'الأحدث',

  '_h._phb': 'الترتيب',

  '_h._qz': 'خلفية',
  '_h._ssww': 'بحث',

  '_h._lsjl': 'السجل',

  '_h._gd': 'المزيد',

  '_h._dl': 'تسجيل الدخول',

  '_h._ye': 'الرصيد',

  '_h._dj': 'مجمد',

  '_h._ybp': 'لوحة التحكم',

  '_h._wdqb': 'محفظتي',

  '_h._scjl': 'المفضلة',

  '_h._xxzx': 'مركز الرسائل',

  '_h._fxhy': 'مشاركة مع الأصدقاء',

  '_h._bzzx': 'مساعدة" مركز',

  '_h._ggtf': 'إعلانات',

  '_h._bqtz': 'استثمار حقوق النشر',

  '_h._sz': 'الإعدادات',

  '_sy._jx': 'مميز',

  '_sy._xpfb': 'إصدارات منتجات جديدة',

  '_sy._gdsp': 'المزيد من الفيديوهات',

  '_qz._jbqz': 'مجموعة خلفيات جميلة',

  '_qz._ssqz': 'البحث عن خلفيات',

  '_qz._qb': 'الكل',

  '_qz._zrfg': 'مناظر طبيعية',

  '_qz._cxys': 'فن تجريدي',

  '_qz._csjz': 'عمارة المدينة',

  '_qz._dmyx': 'أنمي وألعاب',

  '_qz._yzxk': 'كوني" مساحة',

  '_qz._yl': 'معاينة',

  '_qz._xzqz': 'تنزيل الخلفية',

  '_qz._fbl': 'الدقة',

  '_qz._fl': 'الفئة',

  '_qz._jzz': 'جاري التحميل',

  '_qz._myzdpp': 'لم يتم العثور على خلفيات مطابقة',

  '_sp._xyjscl': 'يلزم فتح القفل للعرض',

  '_sp._cz': 'إعادة شحن',
  '_sp._jsqj': 'فتح جميع الحلقات',

  '_sp._jsbj': 'فتح هذه الحلقة',

  '_sp._sc': 'إضافة إلى المفضلة',

  '_sp._fx': 'مشاركة',

  '_sp._jsqjjs': 'هل تريد تأكيد دفع {a} وفتح جميع الحلقات؟',

  '_sp._jsbjjs': 'تأكيد دفع {a} وفتح جميع الحلقات؟',

  '_sp._zfz': 'الدفع جارٍ...',

  '_sp._qrzf': 'تأكيد الدفع',

  '_sp._qx': 'إلغاء',

  '_qz._smrc': 'شروق الشمس فوق الجبال',

  '_qz._cxjh': 'هندسة تجريدية',

  '_qz._dsyj': 'منظر ليلي حضري',

  '_qz._dmfj': 'مناظر الأنمي',

  '_qz._hhxk': 'سماء مرصعة بالنجوم',

  '_qz._slmw': 'ضباب الغابة',
  '_qz._scld': 'تدفق الألوان',

  '_qz._xdjz': 'العمارة الحديثة',

  '_qb._cbjl': 'إيداع السجلات',

  '_qb._jyjl': 'المعاملة" السجلات',

  '_qb._bddz': 'عنوان الربط',

  '_qb._txjl': 'سجلات السحب',

  '_m._tcdl': 'تسجيل الخروج',

  '_m._cb': 'إيداع',

  '_m._tb': 'سحب',

  '_cb._ssdz': 'البحث عن العملة أو العنوان',

  '_cb._bz': 'العملة',

  '_cb._je': 'المبلغ',

  '_cb._dz': 'العنوان',

  '_cb._sj': 'الوقت',

  '_cb._cz': 'العملية',

  '_cb._zwjl': 'لا توجد سجلات معاملات',
  '_cb._dny': ' الصفحة {a} من {b}',

  '_cb._jyxq': ' معاملة التفاصيل',

  '_cb._jydz': ' عنوان المعاملة',

  '_cb._zt': ' الحالة',

  '_cb._yqr': ' مؤكد',

  '_cb._qb': ' الكل',

  '_cb._jt': ' اليوم',

  '_cb._j7t': ' آخر 7 أيام',

  '_cb._j30t': ' آخر 30 يومًا',

  '_cb._zw': ' لا يوجد',

  '_cb._fzcg': ' تم نسخ العنوان إلى الحافظة',

  '_jyjl._ssdz': ' البحث عن العملة أو العنوان',

  '_jyjl._lx': ' النوع',

  '_jyjl._je': ' المبلغ',

  '_jyjl._ye': ' الرصيد ',

  '_jyjl._dj': 'مجمد',

  '_jyjl._sj': 'الوقت',

  '_jyjl._cz': 'العملية',

  '_jyjl._zwjyjl': 'لا توجد سجلات معاملات',

  '_jyjl._czsx': 'إعادة تعيين الفلتر',

  '_jyjl._dny': 'الصفحة {a} من {b}',

  '_jyjl._jyxq': 'تفاصيل المعاملة',

  '_jyjl._jylx': 'نوع المعاملة',

  '_jyjl._jyje': 'مبلغ المعاملة',

  '_jyjl._jyhye': 'الرصيد بعد المعاملة',

  '_jyjl._djye': 'المبلغ المجمد',

  '_jyjl._jysj': 'مدة المعاملة',

  '_jyjl._jyzt': 'حالة المعاملة',

  '_jyjl._ywc': 'مكتمل',

  '_jyjl._qb': 'الكل',

  '_jyjl._jt': 'اليوم',

  '_jyjl._j7t': 'آخر 7 أيام',

  '_jyjl._j30t': 'آخر 30 يومًا',

  '_jyjl._tp1': 'إيداع',

  '_jyjl._tp2': 'سحب',

  '_jyjl._tp3': 'دفع',

  '_jyjl._tp4': 'إيداع',

  '_jyjl._tp5': 'مجمد',

  '_jyjl._tp6': 'أرباح',

  '_jyjl._tp7': 'مكافآت الدعوة',

  '_jyjl._tp8': 'تسجيل الدخول" المكافآت',

  '_jyjl._tp9': 'مكافآت الإحالة',

  '_jyjl._tp10': 'مكافآت مشاهدة الفيديو',
  '_jyjl._tp11': 'مكافأة التسجيل',
  '_jyjl._tp12': 'تم رفض السحب',

  '_jyjl._tp13': 'رسالة في مظروف أحمر',
  '_jyjl._tp14': 'تحويل داخلي',

  '_cb._shz': 'قيد المراجعة',

  '_cb._yyg': 'معتمد',

  '_cb._ybh': 'مرفوض',

  '_bddz._tjdz': 'إضافة عنوان',

  '_bddz._ssdz': 'البحث عن عنوان',

  '_bddz._bz': 'العملة',

  '_bddz._dz': 'العنوان',

  '_bddz._sysj': 'مدة الاستخدام',

  '_bddz._cz': 'العملية',

  '_bddz._zwjl': 'لا يوجد عنوان" السجلات',

  '_bddz._dny': 'الصفحة {a} من {b}',

  '_bddz._dzewm': 'رمز الاستجابة السريعة للعنوان',

  '_bddz._fzdz': 'نسخ العنوان',
  '_bddz._dzxq': 'تفاصيل العنوان',

  '_bddz._wl': 'الشبكة',

  '_bddz._tjsj': 'وقت الإضافة',

  '_bddz._bzwa': 'ملاحظات',

  '_bddz._ntq': 'منذ {a} يوم',

  '_bddz._nxsq': 'منذ {a} ساعة',

  '_bddz._nfzq': 'منذ {a} دقيقة',

  '_bddz._ngg': 'الآن',

  '_bddz._dzyfz': 'تم نسخ العنوان إلى الحافظة',

  '_bddz._scqr': 'تأكيد الحذف',

  '_bddz._scqrdz': 'هل أنت متأكد من حذف هذا العنوان؟',

  '_bddz._qr': 'تأكيد',

  '_bddz._qx': 'إلغاء',

  '_bddz._scdzcg': 'تم حذف العنوان بنجاح',

  '_txjl._ztsx': 'تصفية الحالة',

  '_txjl._qbzt': 'جميع الحالات',

  '_txjl._shz': 'قيد المراجعة',

  '_txjl._ytg': 'مُعتمد',

  '_txjl._yjj': 'مرفوض',

  '_txjl._ssdz': 'ابحث عن العنوان أو المبلغ',

  '_txjl._bz': 'العملة',

  '_txjl._je': 'المبلغ',

  '_txjl._dz': 'العنوان',

  '_txjl._zt': 'الحالة',

  '_txjl._sj': 'الوقت',

  '_txjl._cz': 'العملية',

  '_txjl._zwjl': 'لا توجد سجلات معاملات',

  '_txjl._czsx': 'إعادة تعيين الفلتر',

  '_txjl._dny': ' الصفحة {a} من {b}',

  '_txjl._jyxq': 'تفاصيل المعاملة',

  '_txjl._skdz': 'عنوان الدفع',

  '_txjl._jysj': 'مدة المعاملة',

  '_txjl._jyzt': 'حالة المعاملة',

  '_txjl._fzdz': 'تم نسخ العنوان إلى الحافظة',

  '_cbsq._bz': 'العملة',

  '_cbsq._wl': 'الشبكة',

  '_cbsq._erwm': 'رمز الاستجابة السريعة',

  '_cbsq._fzdz': 'نسخ العنوان',

  '_txsq._bz': 'العملة',

  '_txsq._wl': 'الشبكة',

  '_txsq._ye': 'الرصيد',

  '_txsq._sxf': 'رسوم المعاملة',

  '_txsq._zxtx': 'الحد الأدنى لمبلغ السحب',

  '_txsq._txdz': 'عنوان السحب',

  '_txsq._qxztxdz': 'يرجى تحديد عنوان السحب',

  '_txsq._txje': 'مبلغ السحب',

  '_txsq._qsrtxje': 'الرجاء إدخال مبلغ السحب',

  '_txsq._yxyzm': 'رمز التحقق من البريد الإلكتروني',
  '_txsq._qsryxyzm': 'الرجاء إدخال رمز التحقق',

  '_txsq._ljtx': 'السحب فورًا',

  '_jl._wxhd': 'مفضلتي',

  '_jl._lsjl': 'السجل',

  '_xx._bt': 'مركز الرسائل',

  '_xx._wjl': 'لا توجد سجلات',

  '_xx._zsmyxx': 'لا توجد رسائل حاليًا',

  '_xx._sxxx': 'تحديث الرسائل',

  '_xx._sxcg': 'تم التحديث بنجاح',

  '_fx._fxhy': 'مشاركة مع الأصدقاء',

  '_fx._smfx': 'امسح رمز الاستجابة السريعة للمشاركة مع" الأصدقاء',

  '_fx._jlsm': 'شرح المكافآت',

  '_fx._jlsm1': '1. بالنسبة للأصدقاء الذين تدعوهم مباشرةً, والمُختصرين بالمستوى 1, ستحصل على {a}% من أرباحهم',
  '_fx._jlsm2': '2. إذا قام صديقك من المستوى 1 بدعوة أصدقاء آخرين (المستوى 2), ستحصل على {a}% من أرباحه',

  '_fx._jlsm3': '3. إذا قام صديقك من المستوى 2 بدعوة أصدقاء آخرين (المستوى 3), ستحصل على {a}% من أرباحه',

  '_fx._fzlj': 'نسخ الرابط',

  '_bzzx._bzzx': 'مركز المساعدة',

  '_bzzx._rhzczh': 'كيفية تسجيل حساب',
  '_bzzx._zclc': 'عملية التسجيل',

  '_bzzx._rhzcxyh': 'كيف أنشئ حسابًا جديدًا؟',

  '_bzzx._rhzcxyh1': 'انقر على زر "تسجيل", وأدخل بريدك الإلكتروني, وعيّن كلمة مرور, وأكمل عملية التحقق من بريدك الإلكتروني لتسجيل حساب بنجاح.',

  '_bzzx._rhcz': 'كيف أشحن رصيدي؟',
  '_bzzx._rhcz1': 'عملية إعادة الشحن',

  '_bzzx._rhcz2': 'تعليمات إعادة الشحن المفصلة',

  '_bzzx._rhcz3': 'انقر على "محفظتي""إيداع", ثم اختر العملة المشفرة التي تريد إيداعها, ثم حوّلها إلى العنوان.',

  '_bzzx._rhjsdj': 'كيفية فتح مسلسلات قصيرة',

  '_bzzx._rhjsdj2': 'انقر على حلقة واحدة لفتح حبكة القصة ومشاهدة المزيد من المحتوى المشوق.',

  '_bzzx._rhtx': 'كيفية سحب الأموال من حسابك',

  '_bzzx._rhtx1': '1. انقر على "محفظتي", "عنوان السحب", وأضف عنوان سحب العملة المشفرة المناسب.<br>2. انقر على "سحب", وحدد العملة المشفرة المناسبة, ثم العنوان المرتبط, وأدخل مبلغ السحب, وانتظر وصول الأموال.',

  '_bzzx._qtwt': 'أسئلة أخرى',

  '_bzzx._qtwt1': 'كيف يمكنني التواصل مع خدمة العملاء؟',

  '_bzzx._qtwt2': 'يمكنك التواصل معنا عبر خدمة العملاء عبر الإنترنت في أسفل يمين الموقع, أو عبر البريد الإلكتروني لخدمة العملاء, أو عبر الخط الساخن لخدمة العملاء.',

  '_bzzx._myzdwt': 'ألم تجد الإجابة التي تبحث عنها؟',

  '_bzzx._khjybbzn': 'يسعد فريق خدمة العملاء لدينا بتقديم المزيد من المساعدة لك.',

  '_bzzx._lxkf': 'تواصل مع خدمة العملاء',

  '_ggtf._bt1': 'موضع إعلاني',

  '_ggtf._splb': 'قائمة الفيديوهات',

  '_ggtf._wcyd': 'مشاركاتي',

  '_ggtf._hdbm': 'رمز النشاط',

  '_ggtf._tian': 'اليوم',

  '_ggtf._kssj': 'وقت البدء',

  '_ggtf._jssj': 'وقت الانتهاء',
  '_ggtf._ddvp': 'تم الوصول إلى مستوى VIP{a}, متوسط ​​المشاركة {b} مرة للشخص',

  '_ggtf._hdzt': 'حالة النشاط',

  '_ggtf._wks': 'لم يبدأ',

  '_ggtf._ycy': 'تمت المشاركة',

  '_ggtf._qg': 'تخفيضات سريعة',

  '_ggtf._mygdl': 'لم يعد متاحًا',

  '_ggtf._qgrtd': 'عدد المشاركين كبير جدًا, يُرجى المحاولة مرة أخرى',

  '_ggtf._hdxq': 'تفاصيل النشاط',

  '_ggtf._hdjs': 'مقدمة عن النشاط',

  '_ggtf._cyyq': 'متطلبات المشاركة',

  '_ggtf._zdtz': 'الحد الأدنى للاستثمار',

  '_ggtf._vpdj': 'مستوى كبار الشخصيات',

  '_ggtf._rjcy': 'متوسط ​​المشاركة للشخص الواحد',

  '_ggtf._gmje': 'مبلغ الشراء',
  '_ggtf._qsrgmje': 'يرجى إدخال مبلغ الشراء',

  '_ggtf._qx': 'إلغاء',

  '_ggtf._ljcy': 'المشاركة" الآن',

  '_ggtf._ssjymm': 'أدخل كلمة مرور المعاملة',

  '_ggtf._qssjymm': 'الرجاء إدخال كلمة مرور المعاملة',

  '_ggtf._ji': 'المستوى',

  '_ggtf._ci': 'الأوقات',

  '_ggtf._zdgm': 'الحد الأدنى لمبلغ الشراء',

  '_ggtf._zggm': 'الحد الأقصى لمبلغ الشراء',

  '_ggtf._zfz': 'الدفعة جارية...',

  '_wdtg._wjl': 'لا توجد سجلات مشاركة حتى الآن',

  '_wdtg._tzje': 'مبلغ الاستثمار',

  '_wdtg._zsy': 'إجمالي الأرباح',

  '_wdtg._hdts': 'عدد أيام النشاط',
  '_wdtg._cysj': 'المشاركة" الوقت',

  '_wdtg._qzf': 'متابعة الدفع',

  '_wdtg._jxz': 'قيد التنفيذ',

  '_wdtg._djszje': 'إجمالي المبلغ قيد التسوية',

  '_wdtg._gjb': 'إجمالي {a} معاملة',

  '_wdtg._djs': 'قيد التسوية',

  '_wdtg._zrsy': 'أرباح الأمس',

  '_wdtg._dbl': 'المشاهدات',

  '_wdtg._bfl': 'التشغيلات',

  '_wdtg._wdsy': 'أرباحي',

  '_wdtg._bqffc': 'حصة إيرادات مالك حقوق الطبع والنشر',

  '_wdtg._mr0djs': 'أرباح الأمس" الأرباح مُحَسَّنة يوميًا الساعة 00:00',

  '_wdtg._jrsy': 'أرباح اليوم',

  '_wdtg._mygd': 'لا مزيد',

  '_bqyy._bqyy': 'موعد طلب تعاون حقوق الطبع والنشر',

  '_bqyy._qrbq': 'هل تريد تأكيد طلب تعاون حقوق الطبع والنشر؟',

  '_bqyy._qx': 'إلغاء',

  '_bqyy._tjyy': 'تحديد موعد',

  '_bqyy._spsq': 'موعد طلب تعاون حقوق الطبع والنشر للفيديو',

  '_bqyy._spsy': 'روِّج لفيديوهاتك مع أصحاب حقوق الطبع والنشر وحقق المزيد من الزيارات والإيرادات!',

  '_bqyy._ljyy': 'احجز موعدك الآن',

  '_bqyy._sphz': 'ما هو طلب تعاون حقوق الطبع والنشر للفيديو؟',
  '_bqyy._sphzsm': 'يوفر تطبيق تعاون حقوق الطبع والنشر للفيديو مزيدًا من التعاون الترويجي لتحقيق نتائج مفيدة للطرفين. من خلال التطبيق, ستكتسب تقديرًا من أصحاب حقوق الطبع والنشر, وستتاح لك فرصة التعاون الوثيق معهم, مما يزيد من ظهورك وإيراداتك.',

  '_bqyy._sqhch': 'فوائد التقدم بطلب تعاون في مجال حقوق النشر',
  '_bqyy._llfz': 'دعم حركة المرور',

  '_bqyy._llfzsm': 'احصل على فرص ترويج على المنصة, وزد من ظهورك وعدد مشاهداتك',

  '_bqyy._sytg': 'زيادة الإيرادات',

  '_bqyy._sytgsm': 'احصل على فرص أكبر لمشاركة عائدات الإعلانات والتعاون التجاري',

  '_bqyy._yxhz': 'أولوية التعاون',

  '_bqyy._yxhzsm': 'أولوية المشاركة في أنشطة المنصة الرسمية ومشاريع التعاون التجاري',

  '_bqyy._yytj': 'متطلبات الحجز',

  '_bqyy._sptg': 'متطلبات ترويج إعلانات الفيديو',

  '_bqyy._sptgsm': 'المشاركة" في منصة واحدة على الأقل تتوافق مع معايير منصة ترويج الفيديو',

  '_bqyy._yysm': 'بعد النقر على "حجز", سيتواصل معك فريقنا خلال 3 أيام عمل',

  '_ybp._wdsy': 'إيراداتي',
  '_ybp._dqye': 'الرصيد الحالي',

  '_ybp._jr': 'أرباح اليوم',

  '_ybp._jrzsy': 'إجمالي أرباح اليوم',

  '_ybp._ljzsy': 'إجمالي الأرباح التراكمية',

  '_ybp._tgfh': 'مكافأة الإحالة',

  '_ybp._ljsy': 'الأرباح التراكمية',

  '_ybp._bqsy': 'إيرادات حقوق النشر',

  '_ybp._yqfh': 'مكافأة الإحالة',

  '_ybp._mrsy': 'الأرباح اليومية',

  '_ybp._tgsy': 'إيرادات الإحالة',

  '_tjdz._tjxd': 'إضافة عنوان جديد',

  '_tjdz._xzbz': 'اختيار العملة',

  '_tjdz._qbdz': 'عنوان المحفظة',

  '_tjdz._srdz': 'الرجاء إدخال عنوان المحفظة',
  '_tjdz._qx': 'إلغاء',

  '_tjdz._bc': 'حفظ',

  '_sz._smrz': 'مصادقة الاسم الحقيقي',

  '_sz._rzlx': 'نوع المصادقة',

  '_sz._sfzzm': 'صورة الهوية الأمامية',

  '_sz._sfzfm': 'صورة الهوية الخلفية',

  '_sz._zsxm': 'حقيقي" الاسم',

  '_sz._qsrzsxm': 'الرجاء إدخال الاسم الحقيقي',

  '_sz._sfzhm': 'رقم بطاقة الهوية',

  '_sz._qsrsfzhm': 'الرجاء إدخال رقم بطاقة الهوية',

  '_sz._yyzz': 'رخصة العمل',

  '_sz._qymc': 'اسم الشركة',

  '_sz._yyzzh': 'رقم رخصة العمل',

  '_sz._qsrqymc': 'الرجاء إدخال اسم الشركة',

  '_sz._qsryyzzh': 'الرجاء إدخال رقم رخصة العمل',

  '_sz._qx': 'إلغاء',

  '_sz._tjrz': 'إرسال للتحقق',

  '_sz._zt': 'الحالة',

  '_sz._gr': 'فرد',

  '_sz._qy': 'الشركة',

  '_sz._shz': 'قيد المراجعة',

  '_sz._ytg': 'معتمد',

  '_sz._ybh': 'مرفوض',

  '_mm._xgmm': 'تغيير كلمة المرور',

  '_mm._dqxg': 'تغيير كلمة المرور بانتظام لحماية أمان الحساب',

  '_mm._dqmm': 'كلمة المرور الحالية',

  '_mm._xmm': 'كلمة مرور جديدة',

  '_mm._qrxmm': 'تأكيد كلمة المرور الجديدة',

  '_mm._qx': 'إلغاء',
  '_mm._qrxg': 'تأكيد التغييرات',

  '_jymm._xgjymm': 'تغيير كلمة مرور المعاملة',

  '_szzx._sz': 'الإعدادات',

  '_szzx._yrz': 'مُصادق عليه',

  '_szzx._wrz': 'غير مُصادق عليه',

  '_szzx._jymm': 'كلمة مرور المعاملة',

  '_szzx._szjymm': 'تعيين أو تغيير كلمة مرور المعاملة',

  '_szzx._tcdl': 'تسجيل الخروج',

  '_szzx._qdtcdl': 'هل أنت متأكد من تسجيل الخروج؟',

  '_szzx._qrtc': 'تأكيد تسجيل الخروج',

  '_szzx._qx': 'إلغاء',

  '_yj._gy': 'حول',

  '_yj._lxwm': 'اتصل بنا',

  '_yj._yszc': 'سياسة الخصوصية',

  '_yj._yhxy': 'اتفاقية المستخدم',

  '_cd._gszz': 'مؤهلات الشركة',

  '_cd._wmyy': 'نمتلك مؤهلات وشهادات مهنية كاملة, ونقدم للمستخدمين خدمات فيديو قانونية وآمنة وعالية الجودة',

  '_cd._yyzz': 'إثبات قانوني للعمليات القانونية للشركة, يوضح معلومات تسجيلنا الرسمية ونطاق أعمالنا',

  '_cd._yyzz2': 'رخصة عمل معتمدة من الشركة, حاصلة على ترخيص قانوني, تضمن قانونية المنصة وامتثالها',

  '_bz._lxkf': "انقر أدناه للتواصل مع خدمة العملاء', أو اتصل بنا عبر البريد الإلكتروني لخدمة العملاء أو الخط الساخن",

  '_sz._bjtx': 'تحرير',

  '_sz._bjxx': 'تحرير الرسالة',

  '_sz._tx': 'صورة رمزية',

  '_sz._bcun': 'حفظ',

  '_db._zskf': 'اتصل بالدعم',
  '_db._zsry': 'مندوب خدمة مخصص',
  '_db._wdq': 'غير مقروء',
  '_db._ydq': 'مقروء',

  '_sc._sctp': 'رفع صورة',
  '_sc._xztp': 'اختر صورة',
  '_sc._fstp': 'إرسال الصورة',
  '_sc._qx': 'إلغاء',
  '_sc._hd': 'حسناً',

  '_zcyl._zcbt': 'هدية التسجيل',
  '_zcyl._djdkhb': 'انقر لفتح الظرف الأحمر',
  '_zcyl._zclj': 'مكافأة التسجيل',
  '_zcyl._hmyzh': 'ليس لديك حساب؟',
  '_zcyl._qzc': 'سجل الآن',
  '_zcyl._qxdjhb': 'يرجى المطالبة بالهدية أولاً',
  '_zcyl._qwzc': 'انتقل إلى التسجيل',
  '_zcyl._hbysy': 'تم استخدام الهدية بالفعل',

  '_ggtg._qhz': 'اذهب للتحويل',
  '_ggtg._dqye': 'الرصيد الحالي',
  '_ggtg._qcz': 'اذهب للشحن',
  '_ggtg._hzje': 'مبلغ التحويل',
  '_ggtg._ljhz': 'تحويل فوري',
  '_ggtg._yebz': 'رصيد غير كاف',

  '_sq._bhbt': 'مرفوض',

  '_sq._bhyy': 'سبب الرفض',

  '_xx._ntq': 'منذ {n} يومًا',

  '_xx._nxsq': 'منذ {n} ساعة',

  '_xx._nfzq': 'منذ {n} دقيقة',

  '_xx._nggq': 'الآن',

  '_xx._djckgd': 'انقر لعرض المزيد',

  '_ct._zt': 'الحالة',

  '_ct._ljz': 'جارٍ الاتصال',

  '_ct._ylj': 'متصل',

  '_ct._ltlieb': 'قائمة الدردشة',

  '_ct._bnhzj': 'لا يمكنني الدردشة مع نفسي',

  '_ct._cylb': 'قائمة الأعضاء',

  '_hb._fhb': 'الظرف الأحمر',

  '_hb._dqye': 'الرصيد الحالي',

  '_hb._fsd': 'تم الإرسال إلى',

  '_hb._hbje': 'مبلغ الظرف الأحمر',

  '_hb._qshuru': 'الرجاء إدخال مبلغ الظرف الأحمر',

  '_hb._ljfs': "إرسال' الآن",

  '_hb._hbz': 'دعاء الظرف الأحمر',

  '_hb._qshuruzhu': 'يرجى كتابة دعائك',

  '_sp._cuow': 'يجب فتح الحلقات من 1 إلى 10 قبل أن تتمكن من المشاهدة',

  '_bq._tzzq': 'فترة الاستثمار',

  '_bq._zrsy': 'ربح الأمس',

  '_bq._bqtz': 'استثمار حقوق النشر',

  '_bq._tzdj': 'مبلغ الاستثمار',

  '_bq._zfjz': 'يجب إتمام الدفع خلال 24 ساعة، وإلا سيُعتبر ذلك تنازلاً عن الحق!',

  '_bq._qzf': 'أجرِ الدفع',

  '_bq.jz': 'الموعد النهائي',

  '_bq._ljzf': 'ادفع الآن',

  '_bq._sqbz': 'ملاحظات الطلب (اختياري)',

  '_bq._sqbzsm': 'يرجى إدخال ملاحظاتك على الطلب',

  '_bq._zzsqz': 'طلب حقوق النشر قيد المعالجة، بانتظار المراجعة...',

  '_app._xz': 'حمّل تطبيق ReelShortBiz',

  '_app._smerm': 'امسح رمز الاستجابة السريعة للتحميل',

  '_app._xzbt': 'تنزيل التطبيق',

  '_m._yhzz': 'تحويل بنكي',
  '_m._yhxx': 'معلومات البنك',
  '_m._yhmz': 'اسم البنك',
  '_m._yhdz': 'عنوان البنك',
  '_m._yhmc': 'الاسم',
  '_m._yhzh': 'الحساب',
  '_m._yhlx': 'النوع',
  '_m._yhly': 'التوجيه',
  '_m._yhdm': 'الكود',
  '_m._yhbz': 'ملاحظة',
  '_m._fzxx': 'نسخ المعلومات',

  '_m._zts': 'تنبيه',
  '_m._zyd1': '1. يرجى التحقق بعناية من اسم المستلم ورقم الحساب ورمز البنك عند التحويل، أي خطأ قد يؤدي إلى فقدان الحوالة',
  '_m._zyd2': '2. يُنصح باختيار "المرسل يتحمل جميع الرسوم" لتجنب عدم كفاية المبلغ المستلم بسبب خصم رسوم البنك الوسيط',
  '_m._zyd3': '3. التحويلات تستغرق عادة 1-3 أيام عمل، يرجى الانتظار بصبر، إذا كان لديك أي استفسار يرجى الاتصال بخدمة العملاء',
  '_m._zyd4': '4. إذا كانت لديك أي أسئلة أخرى، يرجى الاتصال بخدمة العملاء',

  '_m._jyh': 'رقم المعاملة',
  '_m._jyje': 'المبلغ',

  '_sp._dbye': 'رصيد الفيديو',
  '_sp.hzye': 'التحويل',
  '_sp._txje': 'مبلغ التحويل',
  '_sp._qsrtxje': 'الرجاء إدخال مبلغ التحويل',
  '_sp._ljhz': 'تحويل فوري',
  '_sp._yebz': 'رصيد غير كاف',
  '_sp._qshuru': 'الرجاء إدخال مبلغ التحويل الصحيح',
  '_sp._fanh': 'العودة',

  '_sp._tliu': 'وضع الإعلانات',
  '_sp._xzgj': 'اختر الدولة',
  '_sp._cdcw': 'خطأ في ترميز الفيديو',
  '_ggtf._hot': 'رائج',
  '_tl._tlsj': 'وقت الإعلان',
  '_tl._xzxb': 'اختر الجنس',
  '_tl._nan': 'ذكر',
  '_tl._nv': 'أنثى',
  '_tl._hunhe': 'مختلط',
  '_tl._xznl': 'اختر العمر',
  '_sp._us': 'الولايات المتحدة',
  '_sp._en': 'المملكة المتحدة',
  '_sp._jp': 'اليابان',
  '_sp._fr': 'فرنسا',
  '_sp._kr': 'كوريا الجنوبية',
  '_sp._de': 'ألمانيا',
  '_sp._id': 'الهند',
  '_sp._in': 'إندونيسيا',
  '_sp._au': 'أستراليا',
  '_sp._es': 'إسبانيا',
  '_sp._my': 'ماليزيا',
  '_sp._cn': 'الصين',
  '_ggtf._fanhui': 'رجوع',
  '_ggtf._jymmts': 'يرجى تأكيد مبلغ المعاملة وإدخال كلمة المرور',
  '_wdtg._wjl_desc': 'لم تشارك في أي حملات إعلانية بعد',
  '_wd._jxz': 'قيد التنفيذ',
  '_wd._djs': 'في انتظار التسوية',
  '_wd._ywc': 'مكتمل',
  '_wd._jz': 'عاجل',
  '_wd._hz': 'تحويل',

  '_tl._tlfbqk': 'توزيع الإنفاق الإعلاني',
  '_tl._tlfbqk_desc': 'الأيام 1-5: 5% (مرحلة البدء البارد)، الأيام 6-10: 20% (مرحلة التحقق من المحتوى)، الأيام 11-15: 40% (مرحلة بناء العلامة التجارية)، الأيام 16-20: 35% (مرحلة مصفوفة المسلسلات القصيرة)',

  '_nhz._sm': 'بعد التحويل، سيتم تحويل المبلغ إلى محفظة الفيديو لفتح محتوى الفيديو',
  '_nhz._zhzz': 'جاري التحويل...',
  '_nhz._zzcg': 'تم التحويل بنجاح',
  '_nhz._zhzsb': 'فشل التحويل، يرجى المحاولة مرة أخرى',
  '_m._fzcg': 'تم النسخ بنجاح',
  '_m._fzsb': 'فشل النسخ، يرجى النسخ يدويًا',
  '_m._zwfzxx': 'لا توجد معلومات للنسخ',
  '_tx._qb': 'الكل',
  'activity.detail': 'تفاصيل النشاط',
  'activity.noDesc': 'لا يوجد وصف للنشاط',
  'activity.desc': 'وصف النشاط',
  'activity.requirements': 'متطلبات المشاركة',
  'activity.minInvest': 'الحد الأدنى للاستثمار',
  'activity.vipLevel': 'مستوى VIP',
  'activity.avgParticipation': 'متوسط المشاركة',
  'activity.avgParticipationDesc': 'مرات',
  'activity.country': 'اختر الدولة',
  'activity.deliveryTime': 'وقت الإعلان',
  'activity.deliveryTimeDesc': 'أيام',
  'activity.gender': 'اختر الجنس',
  'activity.male': 'ذكر',
  'activity.female': 'أنثى',
  'activity.mixed': 'مختلط',
  'activity.age': 'اختر العمر',
  'activity.amount': 'مبلغ الشراء',
  'activity.back': 'رجوع',
  'activity.join': 'مشاركة الآن',
  emptyData: 'لا توجد بيانات',
  emptyDataDesc: 'لا توجد حملات إعلانية مشاركة',
  completedtlement: 'منتهي الصلاحية',
  preheat: 'قيد التسخين',
  progress: 'قيد التنفيذ',
  settlement: 'قيد التسوية',
  transfered: 'تم التحويل',
  completed: 'مكتمل',
  activityCode: 'رمز النشاط',
  touzAmount: 'مبلغ الاستثمار',
  activityDays: 'أيام النشاط',
  joinTime: 'وقت المشاركة',
  playSource: 'توزيع مصادر التشغيل',
  allPlatforms: 'جميع المنصات',
  other: 'أخرى',
  totalPlayNum: 'إجمالي المشاهدات',
  incomeSummary: 'ملخص الأرباح',
  totalPay: 'رسوم حقوق النشر المدفوعة',
  totalIncome: 'إجمالي الدخل',
  copyrightRatio: 'نسبة تقسيم صاحب الحقوق',
  promotionIncome: 'أرباح الترويج',
  copyrightIncome: 'تقسيم حقوق النشر',
  playNum: 'عدد المشاهدات',
  buyNum: 'عدد المشاهدات عند الطلب',
  incomeRate: 'نسبة التقسيم',
  yjIncome: 'الدخل المقدر',
  paid: 'تم الدفع',
  timeout: 'انتهت المهلة',
  transfer: 'تحويل الآن',
  loading: 'جاري التحميل...',
  loadMore: 'تحميل المزيد',
  noMore: 'لا يوجد المزيد',
  nightTime: 'فترة الليل',
  morningTime: 'فترة الصباح',
  afternoonTime: 'فترة الظهيرة',
  eveningTime: 'فترة المساء',
  '_h._tc': 'تسجيل الخروج',
  periodPayment: 'الدفع حسب الفترة',
  periodPaymentDesc: 'يتم التسوية 4 مرات يوميًا على 4 فترات، يمكنك دفع رسوم حقوق النشر حسب الفترة',

  day: 'يوم',
  '_dl._hy': 'مرحباً بعودتك',
  '_dl._cj': 'إنشاء حساب',
  '_dl._zmm': 'إعادة تعيين كلمة المرور',
  '_dl._hyDesc': 'تسجيل الدخول إلى حسابك لمواصلة استكشاف المحتوى الرائع',
  '_dl._cjDesc': 'انضم إلى ReelShortBiz وابدأ رحلتك الرائعة',
  '_dl._zmmDesc': 'أدخل بريدك الإلكتروني وسنرسل رمز التحقق لإعادة التعيين',
  '_dl._hlgqsp': 'موارد أفلام وفيديو عالية الدقة',
  '_dl._gxhty': 'خوارزميات توصية مخصصة',
  '_dl._ffddsp': 'مقاطع فيديو قصيرة غنية',
  '_dl._dlzh': 'تسجيل الدخول',
  '_dl._sdndyx': 'أدخل بريدك الإلكتروني وكلمة المرور للمتابعة',
  '_dl._email': 'البريد الإلكتروني',
  '_dl._qsryx': 'الرجاء إدخال بريدك الإلكتروني',
  '_dl._dlmm': 'كلمة المرور',
  '_dl._qsrmm': 'الرجاء إدخال كلمة المرور',
  '_dl._wjmm': 'نسيت كلمة المرور؟',
  '_dl._immdl': 'تسجيل الدخول الآن',
  '_dl._hmyzh2': 'ليس لديك حساب؟',
  '_dl._ljzc2': 'سجل الآن',
  '_dl._cjzh': 'إنشاء حساب',
  '_dl._jswmd': 'انضم إلى ReelShortBiz وابدأ رحلتك الرائعة',
  '_zh._qszmm': 'الرجاء تعيين كلمة المرور',
  '_zh._qrmm': 'تأكيد كلمة المرور',
  '_zh._qmm': 'الرجاء إعادة إدخال كلمة المرور',
  '_zc._yqm': 'رمز الدعوة',
  '_zc._sryqm': 'الرجاء إدخال رمز الدعوة',
  '_dl._yzm': 'رمز التحقق',
  '_dl._qsryzm': 'الرجاء إدخال رمز التحقق',
  '_dl._yjyzh': 'لديك حساب بالفعل؟',
  '_dl._zcbsty2': 'بالتسجيل أنت توافق على',
  '_dl._zcbstyDesc': 'سياسة الخصوصية',
  '_dl._newmm': 'كلمة مرور جديدة',
  '_dl._qszxmm': 'الرجاء تعيين كلمة مرور جديدة',
  '_dl._qrmm': 'تأكيد كلمة المرور',
  '_dl._qzcsrmm': 'الرجاء إعادة إدخال كلمة المرور الجديدة',
  '_dl._czmm': 'إعادة تعيين كلمة المرور',
  '_dl._xqlmm': 'تذكرت كلمة المرور؟',
  '_dl._fhdl': 'العودة لتسجيل الدخول',
  '_dl._srdllmmbyz': 'كلمتا المرور غير متطابقتين',
  '_dl._czcg': 'تم إعادة تعيين كلمة المرور بنجاح',
  '_h._zc': 'تسجيل',
  // '_ybp._wdsy': 'أرباحي',
  '_ybp._jrsy': 'أرباح اليوم',
  '_ybp._jztr': 'مقارنة بالأمس',
  '_ybp._bfl': 'عدد المشاهدات',
  '_ybp._dbl': 'عدد الطلبات',
  '_ybp._syqs': 'اتجاه الأرباح',
  // '_ybp._jr': 'اليوم',
  '_ybp._t': 'يوم',
  // '_ybp._dqye': 'رصيد الحساب',
  '_ybp._djs': 'قيد التسوية',
  '_ybp._zhl': 'معدل التحويل',
  '_ybp._sjgl': 'نظرة عامة على البيانات',
  '_ybp._zrsy': 'أرباح الأمس',
  '_ybp._bysy': 'أرباح هذا الشهر',
  '_ybp._yysj': 'بيانات التشغيل',
  '_ybp._zr': 'الأمس',
  '_ybp._zjfrs': 'إجمالي عدد المستخدمين المدفوعين',
  '_ybp._mtdqje': 'المبلغ المستحق غداً',
  '_ybp._jsy': 'صافي الأرباح',
  '_ybp._bqfy': 'خطة دفع رسوم حقوق النشر',
  '_ybp._yzf': 'تم الدفع',
  '_ybp._qzf': 'اذهب للدفع',
  '_ybp._bqfyts': 'بعد دفع رسوم حقوق النشر، سيتم ضمان أرباحك وحقوقك أولاً',
  '_ybp._syjl': 'سجل الأرباح',
  '_ybp._ckgd': 'عرض المزيد',
  '_ybp._ssdt': 'التحديثات المباشرة',
  '_ybp._bzzx': 'مركز المساعدة',
  '_ybp._lxkf': 'اتصل بخدمة العملاء',
  '_ybp._zrxz': 'أرباح الأمس',
  '_ybp._zdsy': 'إجمالي الأرباح',
  '_ybp._qygy': 'الشهر الماضي',
  '_ybp._jsjl': 'سجل التسوية',
  '_ybp._hzjl': 'سجل التحويل',
  '_ybp._jfzq': 'دقيقة مضت',
  '_ybp._fzq': 'ساعة مضت',
  '_ybp._djs_mt': 'مبلغ التسوية غداً',
  '_yj._rule': 'قواعد المنصة',

  '_bq._jjks': 'ابدأ الآن',
  '_bq._jxz': 'قيد التنفيذ',
  '_bq._jks': 'الوقت المتبقي للبدء',
  '_bq._jjs': 'الوقت المتبقي للانتهاء',
  '_bq._t': 'ي',
  '_bq._h': 'س',
  '_bq._m': 'د',
  '_bq._s': 'ث',
  '_bq._kssj': 'وقت البدء',
  '_bq._jssj': 'وقت الانتهاء',
  '_bqq._tzdj': 'سعر الوحدة',
  '_bqq._hdts': 'مدة الفعالية',
  '_bqq._vip': 'مستوى VIP',
  '_bqq._rjcy': 'معدل المشاركة',
  '_bqq._cs': 'مرات',
  '_bqq._ysjd': 'تقدم البيع',
  '_bqq._ljqg': 'اشتر الآن',
  '_bqq._zbkqg': 'غير متوفر حالياً',
  '_bqq._jzz': 'جاري التحميل',
  '_bqq._jzgd': 'تحميل المزيد',
  '_bqq._wz': 'لا يوجد المزيد',

  '_sp._gdsj': 'إجمالي {n} حلقة',
  '_sy._jl': 'سجل المدفوعات المعلقة',
  '_ybp._zsy': 'إجمالي الإيرادات',
  '_ybp._djsjl': 'سجل المدفوعات المعلقة',
  '_ybp._bqbm': 'الرمز',
  '_ybp._je': 'المبلغ',
  '_ybp._sj': 'الوقت',
  '_sy._djs': 'معلق',
  '_sy._yjs': 'تم التسوية',
  '_sy._gdstjl': 'إجمالي {n} سجل',
  '_sy._gjd': 'إجمالي {n}',

  '_sp.tgdy':'لا يمكن أن يكون المبلغ أقل من {a}',
  '_sp.tggy':'لا يمكن أن يكون المبلغ أعلى من {a}',

  '_tg._zdyje': 'مبلغ مخصص'
}
